// Feature flags. NEXT_PUBLIC_* — доступні і на клієнті (inlined при білді), і на сервері.
//
// GIFT_CARDS_ENABLED: розділ /gift-cards (reseller-вітрина).
//   • Прод: env НЕ задано → false → нав-лінк прихований, сторінки 404.
//   • Дев: запускати з `NEXT_PUBLIC_GIFT_CARDS=1` для розробки.
export const GIFT_CARDS_ENABLED = process.env.NEXT_PUBLIC_GIFT_CARDS === '1';
